import { useRef, useState } from 'react';
import { useMount } from 'react-use';
import { usePoll } from 'hooks/usePoll';
import {
  ErrorData,
  getReceiveOrderDetails,
  ReceiveOrderDetails,
} from 'onramp-pages/api';
import { useOnrampData } from 'onramp-pages/context';

interface Props {
  onStatusChange: (data: ReceiveOrderDetails, oldStatus?: string) => void;
  startImmediately?: boolean;
}

export const useOrderStatusPolling = ({
  onStatusChange,
  startImmediately = true,
}: Props) => {
  const { receiveOrderPreviewId } = useOnrampData();
  const [orderStatus, setOrderStatus] = useState<string>();
  const [orderErrors, setOrderErrors] = useState<ErrorData[]>([]);
  const [newOrderError, setNewOrderError] = useState<ErrorData>();
  const isFirstPoll = useRef(true);

  const { start, isPolling } = usePoll({
    poll: async () => await getReceiveOrderDetails(receiveOrderPreviewId),
    onPoll: (data) => {
      const { status, errors } = data;
      if (errors) {
        if (errors.length !== orderErrors.length) {
          setOrderErrors(errors);
          if (!isFirstPoll.current) {
            setNewOrderError(errors[errors.length - 1]);
          }
        }
      }
      isFirstPoll.current = false;
      if (status === orderStatus) {
        return null;
      }
      setOrderStatus(status);

      onStatusChange(data, orderStatus);
      return null;
    },
  });

  useMount(() => {
    if (startImmediately) start();
  });

  return { start, error: newOrderError, isPolling };
};
